import { render, staticRenderFns } from "./CartMajorSvg.vue?vue&type=template&id=43b8da24&"
import script from "./CartMajorSvg.vue?vue&type=script&lang=ts&"
export * from "./CartMajorSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports